import { ActionTypes } from "../constants";

const reduceQualifications = (state = [], action) => {

    switch (action.type) {

        case ActionTypes.GET_QUALIFICATIONS_SUCCESS:
            return action.data || [];

        case ActionTypes.GET_QUALIFICATIONS_FAILURE:
            return [];

        case ActionTypes.GET_QUALIFICATION_SUCCESS:
            return [
                ...(state || []).filter(({id}) => Number(id) !== Number(action.payload.id)),
                action.data
            ];

        case ActionTypes.ADD_QUALIFICATION_SUCCESS:
            return !state ? [action.data] : [...state, action.data];

        case ActionTypes.UPDATE_QUALIFICATION_SUCCESS:
            return [
                ...state.filter(({id}) => Number(id) !== Number(action.payload.id)),
                {
                    ...state.find(({id}) => id === action.payload.id),
                    ...action.payload.params
                }
            ];

        case ActionTypes.DELETE_QUALIFICATION_SUCCESS:
            return state.filter(({id}) => Number(id) !== Number(action.payload.id));

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export const getQualification = (qualifications, qualificationId) => !qualifications ? null :  qualifications.find(({id}) => Number(id) === Number(qualificationId));

export default reduceQualifications;
